// extracted by mini-css-extract-plugin
export default {"container":"NewDoctorDashboard_container__wg4Ek","card":"NewDoctorDashboard_card__fWrBp","timer":"NewDoctorDashboard_timer__ifN+V","aiCard":"NewDoctorDashboard_aiCard__R1Kf-"};